import React, {useState} from 'react';
import useOutsideClick from "../../../../hooks/useOutsideClick";
import styles from './styles.module.scss';

interface IPropsIcon {
    isActive: boolean;
}

const AscSortIcon = ({isActive}: IPropsIcon) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M8.46967 15.9697C8.76256 15.6768 9.23744 15.6768 9.53033 15.9697L12 18.4393L14.4697 15.9697C14.7626 15.6768 15.2374 15.6768 15.5303 15.9697C15.8232 16.2626 15.8232 16.7374 15.5303 17.0303L12.5303 20.0303C12.2374 20.3232 11.7626 20.3232 11.4697 20.0303L8.46967 17.0303C8.17678 16.7374 8.17678 16.2626 8.46967 15.9697Z"
                  fill={isActive ? "#959595" : "#1E1E1E"}/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12 13.5C12.4142 13.5 12.75 13.8358 12.75 14.25V19.5C12.75 19.9142 12.4142 20.25 12 20.25C11.5858 20.25 11.25 19.9142 11.25 19.5V14.25C11.25 13.8358 11.5858 13.5 12 13.5Z"
                  fill={isActive ? "#959595" : "#1E1E1E"}/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V10.5C12.75 10.9142 12.4142 11.25 12 11.25C11.5858 11.25 11.25 10.9142 11.25 10.5V9C11.25 8.58579 11.5858 8.25 12 8.25Z"
                  fill={isActive ? "#959595" : "#1E1E1E"}/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12 3.75C12.4142 3.75 12.75 4.08579 12.75 4.5V5.25C12.75 5.66421 12.4142 6 12 6C11.5858 6 11.25 5.66421 11.25 5.25V4.5C11.25 4.08579 11.5858 3.75 12 3.75Z"
                  fill={isActive ? "#959595" : "#1E1E1E"}/>
        </svg>
    )
};

const DescSortIcon = ({isActive}: IPropsIcon) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M8.46967 8.03033C8.76256 8.32322 9.23744 8.32322 9.53033 8.03033L12 5.56066L14.4697 8.03033C14.7626 8.32322 15.2374 8.32322 15.5303 8.03033C15.8232 7.73744 15.8232 7.26256 15.5303 6.96967L12.5303 3.96967C12.2374 3.67678 11.7626 3.67678 11.4697 3.96967L8.46967 6.96967C8.17678 7.26256 8.17678 7.73744 8.46967 8.03033Z"
                  fill={isActive ? "#959595" : "#1E1E1E"}/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12 10.5C12.4142 10.5 12.75 10.1642 12.75 9.75V4.5C12.75 4.08579 12.4142 3.75 12 3.75C11.5858 3.75 11.25 4.08579 11.25 4.5V9.75C11.25 10.1642 11.5858 10.5 12 10.5Z"
                  fill={isActive ? "#959595" : "#1E1E1E"}/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V13.5C12.75 13.0858 12.4142 12.75 12 12.75C11.5858 12.75 11.25 13.0858 11.25 13.5V15C11.25 15.4142 11.5858 15.75 12 15.75Z"
                  fill={isActive ? "#959595" : "#1E1E1E"}/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12 20.25C12.4142 20.25 12.75 19.9142 12.75 19.5V18.75C12.75 18.3358 12.4142 18 12 18C11.5858 18 11.25 18.3358 11.25 18.75V19.5C11.25 19.9142 11.5858 20.25 12 20.25Z"
                  fill={isActive ? "#959595" : "#1E1E1E"}/>
        </svg>
    )
};

const ArrowDownIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M13.0176 7.5542L8.99972 11.5721L4.98186 7.5542" stroke="black" strokeOpacity="0.4"
                  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const DeleteIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M19.2803 4.71967C19.5732 5.01256 19.5732 5.48744 19.2803 5.78033L5.78033 19.2803C5.48744 19.5732 5.01256 19.5732 4.71967 19.2803C4.42678 18.9874 4.42678 18.5126 4.71967 18.2197L18.2197 4.71967C18.5126 4.42678 18.9874 4.42678 19.2803 4.71967Z"
                  fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M4.71967 4.71967C5.01256 4.42678 5.48744 4.42678 5.78033 4.71967L19.2803 18.2197C19.5732 18.5126 19.5732 18.9874 19.2803 19.2803C18.9874 19.5732 18.5126 19.5732 18.2197 19.2803L4.71967 5.78033C4.42678 5.48744 4.42678 5.01256 4.71967 4.71967Z"
                  fill="#1E1E1E"/>
        </svg>
    )
}

const FilterIcon = ({isActive}: IPropsIcon) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M5.57349 3.25C5.58221 3.25 5.59095 3.25 5.59972 3.25L18.4259 3.25C18.6834 3.24998 18.92 3.24997 19.1178 3.26611C19.3309 3.28351 19.5644 3.32333 19.7948 3.44074C20.1248 3.6089 20.3916 3.87687 20.559 4.20541C20.6762 4.43546 20.7162 4.66845 20.7338 4.88172C20.7501 5.08068 20.7501 5.31866 20.7501 5.57802V6.3448C20.7501 6.36038 20.7501 6.37609 20.7502 6.39191C20.7505 6.58338 20.7509 6.79107 20.702 6.99451C20.6585 7.176 20.5862 7.34632 20.4919 7.50027C20.3815 7.68046 20.2336 7.8279 20.0935 7.96753C20.083 7.97809 20.0724 7.9886 20.0619 7.99908L14.9992 13.0618C14.9954 13.0656 14.9916 13.0693 14.9878 13.073C14.9028 13.158 14.8548 13.2064 14.8196 13.2449C14.7975 13.2691 14.7891 13.2803 14.787 13.2833C14.7733 13.3056 14.7631 13.3303 14.757 13.3558C14.7564 13.3594 14.7543 13.3735 14.7528 13.4073C14.7503 13.4618 14.7501 13.5338 14.7501 13.6626V18.011C14.7501 18.0346 14.7502 18.0584 14.7502 18.0824C14.7509 18.3669 14.7517 18.671 14.6544 18.9529C14.5691 19.2002 14.4298 19.4226 14.2498 19.6063C14.0406 19.8199 13.7688 19.9551 13.5123 20.0827C13.4917 20.0929 13.4713 20.1031 13.451 20.1132L12.6238 20.5268C12.2647 20.7063 11.9503 20.8636 11.6866 20.9665C11.4173 21.0716 11.095 21.165 10.744 21.1131C10.2677 21.0428 9.84191 20.7795 9.56606 20.3851C9.36261 20.0942 9.30213 19.7639 9.2758 19.4761C9.25008 19.195 9.25009 18.8444 9.25011 18.4442L9.25011 13.6551C9.25012 13.5288 9.24994 13.4585 9.24749 13.4052C9.24601 13.3729 9.24409 13.3592 9.24345 13.3556C9.23787 13.3324 9.22785 13.3076 9.21291 13.2832C9.2152 13.287 9.21149 13.2789 9.17961 13.2439C9.14299 13.2038 9.09238 13.1529 9.00128 13.0618L3.93853 7.99908C3.92727 7.98782 3.91591 7.9765 3.90449 7.96512C3.76622 7.82733 3.61801 7.67964 3.50809 7.50028C3.41246 7.34421 3.34147 7.17365 3.29847 6.99451C3.24935 6.78992 3.24972 6.58081 3.25006 6.38547C3.25009 6.36934 3.25011 6.3533 3.25011 6.33736V5.6001C3.25011 5.59134 3.25011 5.58261 3.25011 5.5739C3.25009 5.3164 3.25008 5.07987 3.26623 4.88214C3.28363 4.66902 3.32348 4.43576 3.44085 4.20541C3.60863 3.87612 3.87624 3.60852 4.20552 3.44074C4.43577 3.32342 4.66882 3.28354 4.88197 3.26612C5.0796 3.24997 5.31602 3.24998 5.57349 3.25ZM4.8809 4.77972C4.88087 4.77971 4.88136 4.7795 4.88245 4.77914L4.8809 4.77972ZM4.88349 4.77881C4.89237 4.77605 4.92545 4.76757 5.00416 4.76113C5.1332 4.75059 5.30731 4.75 5.59972 4.75H18.3997C18.6921 4.75 18.8665 4.75058 18.9958 4.76114C19.0748 4.76759 19.108 4.77611 19.1169 4.77886C19.1609 4.80204 19.1971 4.83813 19.221 4.88346C19.2237 4.89227 19.2323 4.92544 19.2388 5.00468C19.2494 5.13369 19.2501 5.30797 19.2501 5.6001V6.3448C19.2501 6.47114 19.2499 6.54152 19.2475 6.59487C19.246 6.62719 19.2441 6.64087 19.2434 6.64455C19.238 6.66706 19.2282 6.69162 19.2129 6.71653C19.2111 6.7192 19.2029 6.73052 19.1791 6.75668C19.1426 6.79669 19.092 6.84772 19.0013 6.93842L13.9466 11.9931C13.9427 11.9968 13.9389 12.0006 13.9351 12.0044C13.924 12.0155 13.9128 12.0266 13.9015 12.0379C13.7649 12.174 13.6176 12.3208 13.5081 12.4995C13.4121 12.6561 13.3413 12.827 13.2985 13.0056C13.2494 13.2102 13.2497 13.4191 13.2501 13.6145C13.2501 13.6306 13.2501 13.6467 13.2501 13.6626V18.011C13.2501 18.1995 13.2498 18.3072 13.2447 18.3882C13.2416 18.4382 13.2375 18.459 13.2362 18.4644C13.2248 18.497 13.2057 18.5287 13.1785 18.5565C13.1743 18.5601 13.1576 18.5731 13.114 18.5984C13.0443 18.639 12.9484 18.6875 12.7801 18.7716L11.9801 19.1716C11.5838 19.3697 11.3323 19.4946 11.1412 19.5691C11.0227 19.6154 10.9677 19.6252 10.9522 19.6274C10.8924 19.6158 10.8391 19.5828 10.8019 19.5345C10.7969 19.5196 10.7811 19.466 10.7696 19.3394C10.7509 19.1351 10.7501 18.8542 10.7501 18.411V13.6552C10.7501 13.6396 10.7501 13.6239 10.7502 13.6081C10.7505 13.4166 10.7509 13.209 10.702 13.0056C10.6586 12.8247 10.5866 12.654 10.4919 12.4995C10.382 12.3201 10.2344 12.173 10.096 12.0351C10.0846 12.0237 10.0732 12.0124 10.0619 12.0012L4.99919 6.93842C4.90816 6.84739 4.85738 6.79635 4.82057 6.75602C4.79769 6.73095 4.78918 6.71957 4.78704 6.7165C4.77303 6.69363 4.763 6.66926 4.75702 6.64434C4.75809 6.6488 4.75496 6.64037 4.75278 6.59271C4.75029 6.53818 4.75011 6.46618 4.75011 6.33736V5.6001C4.75011 5.30771 4.7507 5.13344 4.76125 5.00425C4.76769 4.92537 4.7762 4.89221 4.77895 4.88333C4.80247 4.8387 4.83885 4.80232 4.88349 4.77881ZM4.77985 4.88075C4.77986 4.88077 4.77969 4.8813 4.7793 4.88224L4.77985 4.88075ZM19.1195 4.77976C19.1195 4.77977 19.119 4.7796 19.118 4.77922L19.1195 4.77976Z"
                  fill={isActive ? "#959595" : "#1E1E1E"}/>
        </svg>
    )
}

export enum EnumSortType {
    //main table
    problemResult = 'problemResult',
    duration = 'duration',
    callTime = 'callTime',
    operator = 'employee.user.fullName',
    //admin
    companyName = 'companyName',
    status = 'status',
    updatedBy = 'updateUser.fullName ',
    created = 'dateCreate',
    //analytics
    dateCreate = 'phoneCall.callTime',
    analyticsDuration = 'phoneCall.duration',
    analyticsOperator = 'phoneCall.employee.user.fullName',
    analyticsProblemResult = 'phoneCall.numMetricSum',
    orderId = 'phoneCall.order.orderId',
    orderStatus = 'phoneCall.order.status',
    orderOffer = 'phoneCall.order.offer',
    orderSum = 'phoneCall.order.amount',
    group = 'phoneCall.group',
    rating = 'numMetricSum',
    similarityScore = 'similarityScore',
}

export enum EnumSortDirection {
    desc = 'desc',
    asc = 'asc',
}

interface IProps {
    type: EnumSortType;
    title: string;
    selectedSort: string;
    handleSelectSort: (value: string) => void;
    isFilter?: boolean;
    handleOpenFilterModal?: () => void;
    filter?: string | number;
}

const HeadFilter = ({
                        type,
                        title,
                        selectedSort,
                        handleSelectSort,
                        isFilter = false,
                        handleOpenFilterModal,
                        filter
                    }: IProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggleOpen = () => setIsOpen((prev) => !prev);
    const handleClose = () => setIsOpen(false);

    const ref = useOutsideClick(handleClose);

    const handleSort = (e: React.MouseEvent<HTMLButtonElement>) => {
        const sort = e.currentTarget.id;

        handleSelectSort(sort);
        handleClose();
    };

    const isActiveSort = () => {
        if (filter) return true;
        if (!selectedSort) return false;
        return type === selectedSort.split('_')[0];
    };

    const getSortDirection = () => {
        if (!selectedSort) return false;
        return selectedSort.split('_')[1] as EnumSortDirection;
    };

    return (
        <div
            className={styles.filter}
            ref={ref}
        >
            <button
                className={`${styles.filter__head} ${isActiveSort() ? styles.filter__head_active : ''}`}
                type={'button'}
                onClick={handleToggleOpen}
            >
                <div className={styles.filter__title}>
                    <span>
                        {title}
                    </span>
                    <ArrowDownIcon/>
                </div>
                {isActiveSort() && getSortDirection() ? (
                    getSortDirection() === EnumSortDirection.asc ? <AscSortIcon isActive={false}/> :
                        <DescSortIcon isActive={false}/>
                ) : null}
            </button>
            {isOpen ? (
                <div className={styles.filter__list}>
                    {isFilter ? (
                        <button
                            className={`${styles.filter__item} ${Boolean(filter) ? styles.filter__item_active : ''}`}
                            type={'button'}
                            onClick={() => {
                                if (!handleOpenFilterModal) return;
                                handleOpenFilterModal()
                                handleClose()
                            }}
                        >
                            <FilterIcon
                                isActive={Boolean(filter)}
                            />
                            <span>Фільтрувати</span>
                        </button>
                    ) : null}
                    <button
                        className={`${styles.filter__item} ${selectedSort === `${type}_asc` ? styles.filter__item_active : ''}`}
                        type={'button'}
                        id={`${type}_asc`}
                        onClick={handleSort}
                    >
                        <AscSortIcon
                            isActive={selectedSort === `${type}_asc`}
                        />
                        <span>Сортувати від А до Я</span>
                    </button>
                    <button
                        className={`${styles.filter__item} ${selectedSort === `${type}_desc` ? styles.filter__item_active : ''}`}
                        type={'button'}
                        id={`${type}_desc`}
                        onClick={handleSort}
                    >
                        <DescSortIcon
                            isActive={selectedSort === `${type}_desc`}
                        />
                        <span>Сортувати від Я до А</span>
                    </button>
                    {isActiveSort() ? (
                        <button
                            className={styles.filter__item}
                            type={'button'}
                            id={`_`}
                            onClick={handleSort}
                        >
                            <DeleteIcon/>
                            <span>Не сортувати</span>
                        </button>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default HeadFilter;
